import Phaser from 'phaser';

export class Backdrop extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);

    console.log("")
    const graphics = scene.make.graphics({
      x: 0,
      y: 0,
      add: false
    });
    graphics.fillStyle(0x000000, 0.5);
    graphics.fillRect(0, 0, scene.physics.world.bounds.width, scene.physics.world.bounds.height, 10);
    graphics.setInteractive(new Phaser.Geom.Rectangle(0, 0, scene.physics.world.bounds.width, scene.physics.world.bounds.height), Phaser.Geom.Rectangle.Contains);

    this.add(graphics);
    this.scene.add.existing(this);
  }
}
